import TheMultiplicationTableLogo from '~/assets/drill/the-multiplication-table'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function TheMultiplicationTable({
  title,
  completed,
  path,
}: {
  title: string
  path: string
  completed: boolean
}): React.ReactElement {
  const gridMobile = 'row-start-1 row-end-3 col-start-1 col-end-3'
  const gridTablet = 'md:row-start-1 md:row-end-1 md:col-start-1 md:col-end-3'
  const gridDesktop = 'xl:row-start-1 xl:row-end-1 xl:col-start-1 xl:col-end-3'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={TheMultiplicationTableLogo}
      imageClassNames="h-16"
      path={path}
      title={title}
    />
  )
}
